module.exports = __webpack_public_path__ + "img/工艺画-1.e3e62959.jpg";